/*
 * Calculator interface strings, Spanish.
 *
 * The "calc" bucket: the calculator's own chrome, the worksheet cards, the
 * saved-results panel, and the messages about a number that could not be read
 * or that an old result was computed from. English and Spanish only; another
 * interface language falls back to English, or to Spanish when the reader's
 * browser is Spanish (i18n/index.jsx).
 */

/* NOT REVIEWED BY A NATIVE SPEAKER. */

const strings = {
  "calc.minimiseTitle": "Minimizar la calculadora (volver a Gia)",
  "calc.minimiseLabel": "Minimizar la calculadora y volver a Gia",
  "saved.title": "Cálculos guardados",
  "saved.staleSummary": "⚠ {count} de estos se calculó con un método que ya se ha corregido.",
  "saved.staleSummary_one": "⚠ {count} de estos se calculó con un método que ya se ha corregido.",
  "saved.staleSummary_other": "⚠ {count} de estos se calcularon con un método que ya se ha corregido.",
  "saved.staleAction": "Vuelve a calcularlo en la calculadora antes de fiarte de la cifra. Gia no citará resultados sustituidos.",
  "saved.staleAction_one": "Vuelve a calcularlo en la calculadora antes de fiarte de la cifra. Gia no citará resultados sustituidos.",
  "saved.staleAction_other": "Vuelve a calcularlos en la calculadora antes de fiarte de las cifras. Gia no citará resultados sustituidos.",
  "saved.none": "Todavía no hay ninguno. Abre la calculadora desde Herramientas, haz un cálculo y pulsa Guardar en el proyecto.",
  "saved.revision": "Revisión",
  "saved.superseded": "Sustituido",
  "saved.delete": "Eliminar este cálculo guardado",
  "saved.methodChanged": "⚠ El método ha cambiado desde que se guardó.",
  "saved.rerunBefore": "Vuelve a calcular antes de fiarte de las cifras de abajo.",
  "saved.revises": "Revisa el cálculo «{name}» guardado el {ts}. Esa entrada se conserva abajo, sin cambios.",
  "saved.result": "resultado",
  "saved.supersededBy": "Sustituido por una revisión guardada el {ts}. Estas cifras siguen siendo correctas para los datos mostrados, pero ya no son la intención actual.",
  "saved.check": "(revisar)",
  "saved.editTitle": "Carga estos datos en la calculadora para cambiar uno y volver a calcular",
  "saved.editDisabledTitle": "Este resultado es anterior al registro de datos de entrada: vuelve a introducir los valores para recalcular.",
  "saved.edit": "Editar",
  "saved.predates": "Anterior al registro de datos de entrada: vuelve a introducir los valores para recalcular.",
  "calc.choose": "Elige una calculadora",
  "calc.tabCalculator": "Calculadora",
  "calc.tabWorksheet": "Hoja de trabajo",
  "calc.calculate": "Calcular",
  "calc.method": "Método",
  "calc.noProjectRun": "Sin proyecto (solo calcular)",
  "calc.noProjectsYet": "Aún no hay proyectos",
  "calc.projectN": "Proyecto {id}",
  "calc.clearAll": "Borrar todo",
  "calc.emptyTitle": "Aún no hay cálculos.",
  "calc.emptyBody": "Haz uno y se irá apilando aquí con su método, para que puedas construir y citar el diseño de un sistema completo.",
  "calc.methodChanged": "⚠ El método ha cambiado desde que se hizo este cálculo.",
  "calc.rerunBefore": "Vuelve a calcularlo antes de fiarte de este resultado.",
  "calc.check": "(revisar)",
  "calc.rerun": "Recalcular",
  "calc.saved": "Guardado en el proyecto ✓",
  "calc.save": "Guardar en el proyecto",
  "calc.sendToGia": "Enviar a Gia",
  "calc.remove": "Quitar",
  "calc.toast.gone": "Esa calculadora ya no existe.",
  "calc.toast.loaded": "Cargado. Cambia un valor y pulsa Calcular: al guardar se añade una entrada nueva y se conserva la original.",
  "calc.toast.predates": "Este resultado es anterior al registro de los datos de entrada: vuelve a introducir los valores para recalcular.",
  "calc.toast.inputsLoaded": "Datos cargados. Pulsa Calcular para recalcular con el método actual.",
  "calc.toast.noProject": "No hay ningún proyecto seleccionado. Crea o elige uno primero.",
  "calc.toast.savedTo": "Guardado en {name}.",
  "calc.toast.savedToProject": "Guardado en el proyecto.",
  "calc.toast.writeFailed": "No se pudo guardar en el almacenamiento del navegador.",
  "calc.toast.sent": "Enviado a Gia.",
  "calc.misreadNumber": "⚠ Un número escrito en este resultado pudo leerse mal.",
  "saved.misreadNumber": "⚠ Un número escrito en este resultado pudo leerse mal.",
  "calc.misreadNote": "Guardado antes de una corrección en la forma de leer los números escritos ({values}). Si quería decir miles, las cifras de aquí están mal. Vuelva a calcular escribiendo el valor sin el punto, por ejemplo 5000.",
  "calc.ambiguousNumber": "{label}: \"{typed}\" puede significar {a} o {b}. Escriba {a} o {b}.",
};

export default strings;
